export class ApiError extends Error {
  status: number;
  body: any;

  constructor(message: string, status: number, body?: any) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

export function getErrorMessage(error: any): string {
  if (!error) return 'Unknown error';
  if (typeof error === 'string') return error;
  if (error instanceof ApiError) return error.message;
  if (error.message) return error.message;
  if (error.error?.message) return error.error.message;
  return JSON.stringify(error);
}
